import { z } from "zod";

export type Image = {
  id: number;
  sizes: ImageSizesList;
  name: string;
};

export const factoryImage = (id: number, sizes: ImageSizesList, name = ""): Image => ({ id, sizes, name });

/**
 * ========================================
 * <picture> tag setup
 * ========================================
 */

export type ImageHtmlSettings = {
  sources: {
    media: string;
    size: ImageSize;
  }[];
  fallbackSize: ImageSize;
};

export enum ImageSize {
  "0x0" = "0x0",
  "85x64" = "85x64",
  "310x233" = "310x233",
  "467x350" = "467x350",
  "1200x900" = "1200x900",
  "1600x1200" = "1600x1200",
}
const ImageSize_Schema = z.enum(ImageSize);

const ImageUrls_Schema = z.record(z.string(), z.string());
export type ImageUrls = z.infer<typeof ImageUrls_Schema>;

const ImageSizesList_Schema = z.record(ImageSize_Schema, ImageUrls_Schema);
type ImageSizesList = z.infer<typeof ImageSizesList_Schema>;

export type ApiResponseImage = {
  id: number;
} & ApiResponseImageNoId;

const ApiResponse_ImageNoId_Schema = z.object({
  imageUrl: ImageSizesList_Schema,
});
export type ApiResponseImageNoId = z.infer<typeof ApiResponse_ImageNoId_Schema>;
export const ApiResponse_ImagesNoId_Schema = z.array(ApiResponse_ImageNoId_Schema);

export const ImageSize2Width = {
  [ImageSize["0x0"]]: 0,
  [ImageSize["85x64"]]: 85,
  [ImageSize["310x233"]]: 310,
  [ImageSize["467x350"]]: 467,
  [ImageSize["1200x900"]]: 1200,
  [ImageSize["1600x1200"]]: 1600,
};

export const ImageSize2Height = {
  [ImageSize["0x0"]]: 0,
  [ImageSize["85x64"]]: 64,
  [ImageSize["310x233"]]: 233,
  [ImageSize["467x350"]]: 350,
  [ImageSize["1200x900"]]: 900,
  [ImageSize["1600x1200"]]: 1200,
};

/**
 * ========================================
 * Fullscreen gallery types
 * ========================================
 */

export type FullscreenGallery_MediaMetaData = Map<number, string[]>; // number is image index in media array

export type FullscreenGallery_Config = {
  media: Image[];
  index?: number;
  imageHtmlSettings?: ImageSize | ImageHtmlSettings;
  metaData?: FullscreenGallery_MediaMetaData;
};
